import React, { Component } from 'react'
import forOwn from 'mout/object/forOwn'
import contains from 'mout/array/contains'
import getTrueProps from '../../../helpers/getTrueProps'
import { Input, FormGroup, Label, Button } from 'reactstrap'

// props.nodes    props.nodeTags


class NodeAdder extends Component {
  constructor(props) {
    super(props) 

    this.state = {
      selectedOption: '',
    }
  }

  componentWillReceiveProps() {
    this.setState({
      selectedOption: '',
    })
  }

  handleChange(e) {
    this.setState({
      selectedOption: e.target.value,
    })
  }

  render() {
    let nodesCanAdd = []
    let nodeTagsTrueKeys = getTrueProps(this.props.nodeTags)
    forOwn(this.props.nodes, (val, key, o) => {
      if (!contains(nodeTagsTrueKeys, key)) {
        nodesCanAdd.push(val)
      }
    })
    let options = <option value=''></option>
    if (nodesCanAdd && nodesCanAdd !== []) {
      options = nodesCanAdd.map((node, n) => {
        return (
          <option 
            value={node.id} 
            key={'nodeAdderOption' + n} 
          >
            {node.name}
          </option>
        )
      })
      options.splice(0, 0, <option value='' key='nullAdderOption'></option>)
    }
  
  
    return (
      <FormGroup>
        <Label htmlFor='nodeTags'>Add a Node Tag</Label>
        <Input
          type='select'
          name='nodeTags'
          id='nodeTags'
          onChange={(e) => this.handleChange(e)}
          value={this.state.selectedOption}
          disabled={!this.props.active}
        >
          {options}
        </Input>
        <Button 
          onClick={() => this.props.addNodeTag(this.state.selectedOption)}
          disabled={this.state.selectedOption && this.props.active ? false : true}
        >
          Add
        </Button>
      </FormGroup>
    )
  }
}

export default NodeAdder


// WEBPACK FOOTER //
// ./src/components/Content/CreateManageContent/NodeAdder.js